export const QUESTIONNAIRE_TEMPLATE_STATUS = {
  DRAFT: 1,
};
